/* Ralph Christian - new homepage sections. Loaded once even though every
   rc-* section links it (guarded by window.RCH). Works in the theme editor:
   everything re-initialises on shopify:section:load. */
(function () {
  if (window.RCH) return;
  var RCH = (window.RCH = {});
  var desktop = window.matchMedia('(min-width: 990px)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Videos: rendered without autoplay so the hidden desktop/mobile copy never
     downloads. Play only the copy that is visible, and only on screen. */
  function syncVideos(root) {
    var vids = root.querySelectorAll('.rch-v video');
    vids.forEach(function (v) {
      var visible = v.offsetParent !== null && v.getClientRects().length > 0;
      if (!visible || reduced.matches) { if (!v.paused) v.pause(); return; }
      if (v.getAttribute('preload') === 'none') v.setAttribute('preload', 'auto');
      v.muted = true;
      if (v._rchSeen !== false) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    });
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target; v._rchSeen = e.isIntersecting;
      if (!e.isIntersecting) { v.pause(); } else if (v.offsetParent !== null && !reduced.matches) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    });
  }, { threshold: 0.15 }) : null;

  /* Mobile side-by-side hero: first TAP widens that side, second tap follows the link.
     Only pointer taps are intercepted - keyboard and screen-reader activation (no
     preceding pointerdown) always follows the link straight away. */
  function initSplit(root) {
    root.querySelectorAll('.rch-hero__dual[data-mobile="split"]').forEach(function (row) {
      if (row.dataset.rchInit) return;
      row.dataset.rchInit = '1';
      var panels = row.querySelectorAll('.rch-hero__panel');
      panels.forEach(function (p) {
        var lastPointer = 0;
        p.addEventListener('pointerdown', function () { lastPointer = Date.now(); });
        p.addEventListener('click', function (e) {
          if (desktop.matches) return;
          if (Date.now() - lastPointer > 1000) return;
          if (!p.classList.contains('is-open')) {
            e.preventDefault();
            panels.forEach(function (x) { x.classList.toggle('is-open', x === p); });
          }
        });
      });
    });
  }

  /* Product tabs (ARIA tabs pattern, arrow keys move between tabs). */
  function initTabs(root) {
    root.querySelectorAll('[data-rch-tabs]').forEach(function (wrap) {
      if (wrap.dataset.rchInit) return;
      wrap.dataset.rchInit = '1';
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]'));
      var viewAll = wrap.querySelector('[data-rch-viewall]');
      var viewAllName = wrap.querySelector('[data-rch-viewall-name]');
      function select(t, focus) {
        if (viewAll && t.dataset.rchLink) viewAll.setAttribute('href', t.dataset.rchLink);
        if (viewAllName && t.dataset.rchLinkName) viewAllName.textContent = ' ' + t.dataset.rchLinkName;
        tabs.forEach(function (x) {
          var on = x === t;
          x.setAttribute('aria-selected', on ? 'true' : 'false');
          x.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(x.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) t.focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          if (n) { e.preventDefault(); select(n, true); }
        });
      });
    });
  }

  /* ADD: posts to Shopify's /cart/add.js and CHECKS the response (the theme's own
     addToCart opens the mini-cart even when the add fails). On success it refreshes
     the theme's Alpine cart and opens the mini-cart exactly as the theme does
     (store('cart').getCart(), store('globals').minicart/overlay = true). Without
     Alpine it falls back to a normal form post. Result is announced to screen readers. */
  function announce(form, msg) {
    var sec = form.closest('.rch');
    var live = sec && sec.querySelector('[data-rch-status]');
    if (live) { live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 50); }
  }
  function initAdd(root) {
    root.querySelectorAll('form[data-rch-add]').forEach(function (form) {
      if (form.dataset.rchInit) return;
      form.dataset.rchInit = '1';
      form.addEventListener('submit', function (e) {
        var A = window.Alpine;
        var cart = A && A.store && A.store('cart');
        var globals = A && A.store && A.store('globals');
        if (!cart || !window.fetch) return;
        e.preventDefault();
        var btn = form.querySelector('button');
        if (btn.getAttribute('aria-busy') === 'true') return;
        var label = btn.querySelector('[data-rch-add-label]');
        if (label && !label.dataset.orig) label.dataset.orig = label.textContent;
        var original = label ? label.dataset.orig : '';
        var name = btn.dataset.name || '';
        var id = parseInt(form.querySelector('[name="id"]').value, 10);
        var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        btn.setAttribute('aria-busy', 'true');
        function done(text, msg) {
          btn.removeAttribute('aria-busy');
          if (label) {
            clearTimeout(label._rchReset);
            label.textContent = text;
            label._rchReset = setTimeout(function () { label.textContent = original; }, 2000);
          }
          announce(form, msg);
        }
        fetch(routes + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        }).then(function () {
          var refresh = typeof cart.getCart === 'function' ? cart.getCart() : null;
          var open = function () { if (globals) { globals.minicart = true; globals.overlay = true; } };
          Promise.resolve(refresh).then(function () {
            if (cart.cartBusy && typeof cart.getCart === 'function') {
              return new Promise(function (res) { setTimeout(res, 400); }).then(function () { return cart.getCart(); });
            }
          }).then(open, open);
          done(btn.dataset.added || 'Added', (btn.dataset.addedMsg || 'Added to your bag') + (name ? ': ' + name : ''));
        }).catch(function () {
          done(btn.dataset.failed || 'Unavailable', (btn.dataset.failedMsg || 'Could not add to your bag') + (name ? ': ' + name : ''));
        });
      });
    });
  }

  /* Theme editor: selecting a tab block shows that tab. */
  document.addEventListener('shopify:block:select', function (e) {
    var t = e.target;
    if (t && t.getAttribute && t.getAttribute('role') === 'tab') t.click();
  });

  /* Hero fit-to-screen: measure everything above the hero (top banner, header,
     product banner) so the hero fills the rest of the screen minus the peek.
     Also measure the trust overlay so the hero labels lift clear of it. */
  function measureHero(h) {
    if (h.dataset.fit === 'on') {
      var top = Math.max(0, Math.round(h.getBoundingClientRect().top + window.pageYOffset));
      h.style.setProperty('--rch-hero-top', top + 'px');
      /* Gap between the hero's bottom and the next section's first visible content
         (its top spacing), so the peek shows the heading, not empty padding. */
      var wrap = h.closest('.shopify-section') || h;
      var next = wrap.nextElementSibling;
      while (next && (next.offsetHeight === 0 || /^(SCRIPT|STYLE|LINK)$/.test(next.tagName) || next.classList.contains('rch-hero-bar'))) next = next.nextElementSibling;
      if (next) {
        var walker = document.createTreeWalker(next, NodeFilter.SHOW_TEXT, { acceptNode: function (n) {
          return n.nodeValue.trim() && n.parentElement && n.parentElement.offsetParent !== null && !/^(SCRIPT|STYLE)$/.test(n.parentElement.tagName) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT; } });
        var firstText = walker.nextNode();
        var nextTop = next.getBoundingClientRect().top;
        var contentTop = firstText ? firstText.parentElement.getBoundingClientRect().top : nextTop;
        var gap = Math.max(0, Math.min(240, Math.round(contentTop - nextTop)));
        h.style.setProperty('--rch-peek-gap', gap + 'px');
      }
    }
    var ov = h.querySelector('.rch-hero__overlay');
    if (ov) h.style.setProperty('--rch-ov-h', Math.round(ov.getBoundingClientRect().height) + 'px');
    var bar = heroBar(h);
    if (bar) h.style.setProperty('--rch-bar-h', Math.round(bar.getBoundingClientRect().height) + 'px');
    overlaysOf(h).forEach(fitOv);
  }
  /* The mobile bar sits just after the hero (and its inline script), inside the same section. */
  function heroBar(h) {
    var el = h.nextElementSibling;
    while (el && el.tagName === 'SCRIPT') el = el.nextElementSibling;
    return el && el.classList.contains('rch-hero-bar') ? el : null;
  }
  function overlaysOf(h) {
    var list = Array.prototype.slice.call(h.querySelectorAll('.rch-hero__overlay'));
    var bar = heroBar(h);
    if (bar) list = list.concat(Array.prototype.slice.call(bar.querySelectorAll('.rch-hero__overlay')));
    return list;
  }
  /* Items that already fit stay still and centred instead of scrolling. */
  function fitOv(ov) {
    var list = ov.querySelector('.rch-hero__ov-list:not(.rch-hero__ov-list--clone)');
    if (!list || !ov.offsetWidth) return;
    ov.removeAttribute('data-fits');
    var w = 0;
    Array.prototype.forEach.call(list.children, function (li) { if (li.offsetWidth) w += li.offsetWidth; });
    var cs = getComputedStyle(list);
    var n = Array.prototype.filter.call(list.children, function (li) { return li.offsetWidth; }).length;
    w += (parseFloat(cs.columnGap) || 0) * Math.max(0, n - 1) + (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
    if (w <= ov.clientWidth) ov.setAttribute('data-fits', '');
  }
  function initHero(root) {
    root.querySelectorAll('.rch-hero').forEach(function (h) {
      overlaysOf(h).forEach(function (ov) {
      if (ov.dataset.mobile === 'ticker' && !ov.dataset.rchInit) {
        ov.dataset.rchInit = '1';
        var track = ov.querySelector('.rch-hero__ov-track');
        var list = ov.querySelector('.rch-hero__ov-list');
        var clone = list.cloneNode(true);
        clone.classList.add('rch-hero__ov-list--clone');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a, button, [tabindex]').forEach(function (el) { el.setAttribute('tabindex', '-1'); });
        clone.querySelectorAll('[data-shopify-editor-block]').forEach(function (el) { el.removeAttribute('data-shopify-editor-block'); });
        track.appendChild(clone);
        ov.style.setProperty('--rch-ov-duration', Math.max(8, list.scrollWidth / 40) + 's');
      }
      });
      measureHero(h);
    });
  }
  var heroTimer = null;
  function remeasure() {
    clearTimeout(heroTimer);
    heroTimer = setTimeout(function () { document.querySelectorAll('.rch-hero').forEach(measureHero); }, 100);
  }
  window.addEventListener('resize', remeasure);
  window.addEventListener('load', remeasure);
  /* Banners above the hero can change height after load (e.g. Global-e's message). */
  setTimeout(remeasure, 1500);
  setTimeout(remeasure, 4000);

  function init(root) {
    root = root || document;
    initSplit(root); initTabs(root); initAdd(root); initHero(root);
    root.querySelectorAll('.rch-v video').forEach(function (v) { if (io) io.observe(v); });
    syncVideos(root);
  }
  RCH.init = init;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  var onChange = function () { syncVideos(document); };
  if (desktop.addEventListener) desktop.addEventListener('change', onChange); else desktop.addListener(onChange);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
